<section id="dj" class="wl-section dj">
  <div class="wl-inner inner">
    <app-section-heading
      eyebrow="Panel prowadzącego"
      title="Cała gra w dłoni prowadzącego"
      subtitle="Prowadzący steruje wszystkim z telefonu. Nie potrzebuje specjalnego urządzenia ani plątaniny kabli. Trzy kliknięcia i sala gra." />

    <div class="wl-dj-viewport viewport" (pointerdown)="onPointerDown($event)">
      <div class="wl-dj-track" [style.transform]="trackTransform()">
        @for (phone of phones; track phone.n) {
          <div class="wl-dj-slide">
            <div class="phone">
              <div class="notch"></div>
              <div class="screen">{{ phone.placeholder }}</div>
            </div>
            <div class="caption">
              <span class="num">{{ phone.n }}</span>
              <h3 class="caption-title">{{ phone.title }}</h3>
            </div>
            <p class="caption-text">{{ phone.text }}</p>
          </div>
        }
      </div>
    </div>

    <!-- STEROWANIE KARUZELĄ (tylko mobile) -->
    <div class="wl-dj-controls">
      <button (click)="prev()" [disabled]="index() === 0" aria-label="Poprzedni" class="arrow">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
      </button>

      <div class="dots">
        @for (phone of phones; track phone.n; let i = $index) {
          <button (click)="go(i)" [attr.aria-label]="'Slajd ' + (i + 1)" class="dot" [class.active]="index() === i"></button>
        }
      </div>

      <button (click)="next()" [disabled]="index() === phones.length - 1" aria-label="Następny" class="arrow">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
      </button>
    </div>
  </div>
</section>
